import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private _shouldCloseMenu = signal(false);

  shouldCloseMenu = this._shouldCloseMenu.asReadonly();

  closeMenu() {
    this._shouldCloseMenu.set(true);
    setTimeout(() => this._shouldCloseMenu.set(false), 0);
  }
}
